import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'

const CardList = lazy(() => import('@/modules/MyCards/pages/CardList'))
const CardDetails = lazy(() => import('@/modules/MyCards/pages/CardDetails'))

const MyCardsRoutes = [
  <RequireAuthentication
    path="/pagamentos"
    key="/pagamentos"
    exact
    component={CardList}
  />,
  <RequireAuthentication
    path="/pagamentos/cartao/:cardId"
    key="/pagamentos/cartao/:cardId"
    exact
    component={CardDetails}
  />,
]

export default MyCardsRoutes
